<template>
  <warehouse-list :enable="false"></warehouse-list>
</template>

<script>
import WarehouseList from '@/pages/appraisal/warehouse/list.vue'
export default {
  name: 'AiWarehousePage',
  components: { WarehouseList }
}
</script>
